import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface DynamicLogoProps {
  className?: string;
  showText?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const DynamicLogo: React.FC<DynamicLogoProps> = ({ 
  className = '', 
  showText = true, 
  size = 'md' 
}) => {
  const { theme, isLoading } = useTheme();

  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  // Verificar se className contém classes de tamanho customizadas (w-* ou h-*)
  const hasCustomSize = /\b(w-\d+|h-\d+)\b/.test(className);
  const logoSizeClass = hasCustomSize ? '' : sizeClasses[size];

  if (isLoading || !theme) {
    return (
      <div className={`flex items-center ${className}`}>
        <h1 className={`font-bold text-white ${textSizeClasses[size]}`}>
          U2P CMS
        </h1>
      </div>
    );
  }

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {theme.logoUrl ? (
        <>
          <img 
            src={theme.logoUrl} 
            alt={theme.cmsName || 'CMS'}
            className={`${logoSizeClass} ${hasCustomSize ? className : ''} object-contain transition-all duration-300`}
            onError={(e) => {
              // Fallback para texto se a imagem falhar
              const img = e.currentTarget;
              const text = img.nextElementSibling as HTMLElement;
              if (img && text) {
                img.style.display = 'none';
                text.style.display = 'block';
              }
            }}
          />
          {showText && (
            <h1 className={`font-bold text-white hidden ${textSizeClasses[size]}`}>
              {theme.cmsName || 'CMS'}
            </h1>
          )}
        </>
      ) : (
        showText && (
          <h1 className={`font-bold text-white ${textSizeClasses[size]}`}>
            {theme.cmsName || 'CMS'}
          </h1>
        )
      )}
    </div>
  );
};

export default DynamicLogo;
